import { frontendURL } from '../../../../helper/URLHelper';
import { INBOX_PERMISSIONS } from 'dashboard/constants/permissions.js';
import ChannelFactory from './ChannelFactory.vue';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import InboxHome from './Index.vue';
import Settings from './Settings.vue';
import InboxChannel from './InboxChannels.vue';
import ChannelList from './ChannelList.vue';
import AddAgents from './AddAgents.vue';
import FinishSetup from './FinishSetup.vue';
import { isApiInboxDisabledForAccount } from './apiInboxVisibility';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsWrapper,
      meta: {
        connectionsNavigation: true,
        connectionSection: 'inboxes',
      },
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_inbox_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          meta: {
            permissions: ['administrator', INBOX_PERMISSIONS],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      meta: {
        connectionsNavigation: true,
        connectionSection: 'inboxes',
      },
      props: params => {
        const createFlowRoutes = [
          'settings_inbox_new',
          'settings_inboxes_page_channel',
          'settings_inboxes_add_agents',
          'settings_inbox_finish',
        ];
        const isCreateFlow = createFlowRoutes.includes(params.name);
        const showBackButton =
          !isCreateFlow && params.name !== 'settings_inbox_list';
        const fullWidth = params.name === 'settings_inbox_show';
        const hasOwnHeader = isCreateFlow || fullWidth;
        return {
          headerTitle: hasOwnHeader ? '' : 'INBOX_MGMT.HEADER',
          icon: hasOwnHeader ? '' : 'mail-inbox-all',
          showBackButton: hasOwnHeader ? false : showBackButton,
          fullWidth,
        };
      },
      children: [
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              meta: {
                permissions: ['administrator', INBOX_PERMISSIONS],
              },
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              meta: {
                permissions: ['administrator', INBOX_PERMISSIONS],
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inboxes_page_channel',
              component: ChannelFactory,
              beforeEnter: to => {
                if (
                  to.params.sub_page === 'api' &&
                  isApiInboxDisabledForAccount(to.params.accountId)
                ) {
                  return {
                    name: 'settings_inbox_new',
                    params: { accountId: to.params.accountId },
                  };
                }

                return true;
              },
              meta: {
                permissions: ['administrator', INBOX_PERMISSIONS],
              },
              props: route => {
                return { channelName: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              meta: {
                permissions: ['administrator', INBOX_PERMISSIONS],
              },
              component: AddAgents,
            },
          ],
        },
        {
          path: ':inboxId/:tab?',
          name: 'settings_inbox_show',
          component: Settings,
          meta: {
            permissions: ['administrator', INBOX_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
